export default __webpack_public_path__ + "static/triangle-right2-63da85a461deb8247ec9cb4286264272.png";